<script setup>
    import { ref } from 'vue'
    import { ElCollapse } from 'element-plus'
    import GeneralGroup from './field-groups/general.vue'
    import PriceGroup from './field-groups/price.vue'
    import Inventory from './field-groups/inventory.vue'
    import Shipping from './field-groups/shipping.vue'
    import LinkedProducts from './field-groups/linked-products.vue'
    import Downloadable from './field-groups/downloads.vue'
    import Attributes from './field-groups/attributes.vue'
    import Variations from './field-groups/variations.vue'
    import Dummy from './field-groups/dummy.vue'
    import { ArrowDownBold } from '@element-plus/icons-vue'
    import { storeToRefs } from 'pinia'
    import { useProductStore } from '../stores/fpe'

    const activeTab = ref('general');

    const strings = fpe.strings;

    const pro = ref(fpe.editor_config.pro || false);
    const { product } = storeToRefs(useProductStore());
    
    const productType = ref(product.value.type);
    if(fpe.editor_config.tabs_collapsed) {
        activeTab.value = '';
    } else {
        const defaultTab = fpe.editor_config.default_tab || 'general';
        activeTab.value = defaultTab;
    }
    
</script>

<template>
    <el-collapse v-model="activeTab" @change="handleChange" accordion> 
      <GeneralGroup  />
      <PriceGroup v-if="productType != 'variable'"/>
      <Inventory /> 
      <Shipping />
      <LinkedProducts v-if="pro" />
      <Dummy :title="strings.section_title_linked_products" v-else />
      <Downloadable v-if="pro" />
      <Dummy :title="strings.section_title_downloads" v-else />
      <Attributes v-if="pro" />
      <Dummy :title="strings.section_title_attributes" v-else />
      <Variations v-if="productType == 'variable' " />
      <!-- <Dummy :title="strings.section_title_variations" v-if="productType= 'variable' && !pro" /> -->
    </el-collapse>    
</template>